export const formatPiiWarning = (categories: string[]): string | null => {
  if (!categories || categories.length === 0) {
    return null;
  }

  return `Possible personal data detected (${categories.join(', ')}). Avoid storing personal data in the rubric.`;
};
